import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_440: DocMigration = {
  maxSchemaVersion: "0.0.440",
  description: "Remove cascade roof support",
  apply(json: any) {
    for (const roofId in json.roofs) {
      const roof = json.roofs[roofId];

      delete roof.cascade;
      delete roof.cascadeSplitDepth;
      delete roof.cascadeSplitStart;
      delete roof.cascadeSplitEnd;
      delete roof.cascadeInvertDepth;
      delete roof.normalizedCascadeValues;
    }

    return json;
  },
};

export default migration_0_0_440;
